<template>
  <div>

    <b-card title="Introduction">
      <b-card-body>
        <p> As you can see in the tables, belows, the total number of values representable is directly correlated to the number of
            bits used. With 1-bit, there are 2 values representable, with 2-bits, there are 4 values representable and with 3-bits
            there are 8 values representable. Put another way, every bit added doubles the number of values that are representable.
            Mathematically we say there are 2<sup>n</sup> different values represetable with n-bits.
        </p>
        <p> For any number of bits, the lowest unsigned integer value representable is 0. The highest unsgined integer value 
          representable is the number of bits minus 1 (because the first number is zero, not 1). In general we can say the the 
          range of representable unsigned integer values for n-bits is 0 to 2<sup>n</sup> - 1.
        </p>
        <table>
          <tr>
            <td>
              <b-table :items="bits1" class="ranges-bits"/>
              <span class="footer">2<sup>1</sup> = 2 values</span></td>
            <td><b-table :items="bits2" class="ranges-bits"/>
              <span class="footer">2<sup>2</sup> = 4 values</span></td>
            <td><b-table :items="bits3" class="ranges-bits"/>
              <span class="footer">2<sup>3</sup> = 8 values</span></td>
            <td><b-table :items="bits4" class="ranges-bits"/>
              <span class="footer">2<sup>4</sup> = 16 values</span></td>
          </tr>
        </table>
      </b-card-body>
    </b-card><p/>
    <b-card title="Try it yourself">
      <b-card-body>
        <table>
          <tr>
            <td class="ranges-range">
              # of bits =  
            </td>
            <td class="ranges-range">
              <b-form-input type="number" v-model="bits" class="ranges-n" :min="0" :max="70"/>
            </td>
            <td class="ranges-range">
              The range of representable numbers for an {{bits}}-bit unsigned integer is 0 to {{((2 ** bits) - 1).toLocaleString()}} 
            </td>
          </tr>
        </table>
      </b-card-body>
    </b-card><p/>

    </div>
</template>

<script>

export default {
  data () {
    return {
      bits: 0,
      bits1: [
        {value: 0, bits: '0'},
        {value: 1, bits: '1'}
      ],
      bits2: [
        {value: 0, bits: '00'},
        {value: 1, bits: '01'},
        {value: 2, bits: '10'},
        {value: 3, bits: '11'}
      ],
      bits3: [
        {value: 0, bits: '000'},
        {value: 1, bits: '001'},
        {value: 2, bits: '010'},
        {value: 3, bits: '011'},
        {value: 4, bits: '100'},
        {value: 5, bits: '101'},
        {value: 6, bits: '110'},
        {value: 7, bits: '111'}
      ],
      bits4: [
        {value: 0, bits: '0000'},
        {value: 1, bits: '0001'},
        {value: 2, bits: '0010'},
        {value: 3, bits: '0011'},
        {value: 4, bits: '0100'},
        {value: 5, bits: '0101'},
        {value: 6, bits: '0110'},
        {value: 7, bits: '0111'},
        {value: 8, bits: '1000'},
        {value: 9, bits: '1001'},
        {value: 10, bits: '1010'},
        {value: 11, bits: '1011'},
        {value: 12, bits: '1100'},
        {value: 13, bits: '1101'},
        {value: 14, bits: '1110'},
        {value: 15, bits: '1111'}
      ]
    }
  }
}
</script>

<style scoped>
.ranges-bits {
  max-width: 75px;
  vertical-align: top;
}

.ranges-range {
  vertical-align: middle;
  padding-right: 5px;
  font-size: large;
}

.ranges-n {
  max-width: 70px;
}

tr, td {
  vertical-align: top;
  padding-right: 3.5em;
}
</style>


// WEBPACK FOOTER //
// src/components/ranges.vue